import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/atoms/ui/carousel'

import { cn } from '@/lib/utils'

interface OurServiceProps {
  data: PMA['items'][0]['fields']['features']
}

export const AssistCarousel = ({ data }: OurServiceProps) => {
  return (
    <Carousel
      id="top"
      opts={{
        align: 'start'
      }}
      className="relative"
    >
      <CarouselContent className="my-0.5 -ml-4">
        {data?.map((item, index) => (
          <CarouselItem key={index} className={cn('pl-4 sm:basis-1/2 lg:basis-1/4')}>
            <figure
              key={index}
              className="text-center border border-gray-300 rounded-xl px-4 py-5 xl:p-7 h-[290px] lg:h-full m-4 lg:m-0"
            >
              <figcaption className="space-y-5">
                <span className="text-xl font-bold text-primary-blue">{item.title}</span>
                <div className="w-[50px] h-1 mx-auto rounded-lg bg-secondary-yellow" />
                <p
                  className="text-sm lg:text-base line-clamp-[7] lg:line-clamp-none"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              </figcaption>
            </figure>
          </CarouselItem>
        ))}
      </CarouselContent>
      <div className="lg:hidden">
        <CarouselPrevious
          className="absolute z-10 flex items-center justify-center w-10 h-10 translate-y-[-50%] bg-transparent border border-gray-300 rounded-full text-primary-blue bg-white hover:text-white disabled:text-primary-blue/60 hover:bg-primary-blue top-[50%] -left-2 lg:-left-10 group"
          customArrow={<ChevronLeftIcon className="w-5 h-5" />}
        />
        <CarouselNext
          className="absolute z-10 flex items-center justify-center w-10 h-10 translate-y-[-50%] bg-transparent border border-gray-300 rounded-full text-primary-blue bg-white hover:text-white disabled:text-primary-blue/60 hover:bg-primary-blue top-[50%] -right-2 lg:-right-10 group"
          customArrow={<ChevronRightIcon className="w-5 h-5" />}
        />
      </div>
    </Carousel>
  )
}
